var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWalls = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.793 12.429v6.448c0 1.143-1.047 2.085-2.318 2.085L8.615 21c-1.272 0-2.319-.942-2.319-2.085v-6.448",
  stroke: "currentColor",
  strokeWidth: 2.25,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m4 9.301 6.782-6.595c.972-.941 2.564-.941 3.525 0L21.09 9.3",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "0.5 3"
})));
export { SvgWalls as Component };